import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";

import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";

const ComplaintsFormStepTwo = (props) => {
  const { t } = useTranslation();

  const [customerExpectationsSelect, setCustomerExpectationsSelect] = useState(
    [],
  );
  const [guarantorSelect, setGuarantorSelect] = useState([]);

  useEffect(() => {
    const fetchDictionaries = async () => {
      const expectationsFetch = GlobalAuthFetch({
        path: "/dictionary/customerExpectations/fieldName",
      });
      const guarantorFetch = GlobalAuthFetch({
        path: "/dictionary/guarantor/fieldName",
      });

      const [expectationsPayload, guarantorPayload] = await Promise.all([
        expectationsFetch,
        guarantorFetch,
      ]);

      setCustomerExpectationsSelect(
        expectationsPayload?.payload?.data?.dictionaryEntries || [],
      );
      setGuarantorSelect(
        guarantorPayload?.payload?.data?.dictionaryEntries || [],
      );
    };

    fetchDictionaries();
  }, []);

  return (
    <div style={{ justifyContent: "flex-start", paddingTop: "10px" }}>
      {/* ----------------- ZGŁOSZENIE KLIENTA ----------------- */}
      <BMXSeparator title={t("global:complaints.customerRequest")} />

      <Row>
        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={t("global:complaints.complaintReason")}
            name="complaintReason"
            data-cy="complaintReason"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXSelectField}
            values={customerExpectationsSelect?.map((el) => ({
              name: el.entryName,
              value: el.uuid,
            }))}
            label={t("global:complaints.customerExpectations")}
            name="customerExpectations"
            data-cy="customerExpectations"
          />
        </Col>
      </Row>

      <Row>
        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={t("global:complaints.complaintRemarks")}
            name="complaintRemarks"
            data-cy="complaintRemarks"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={t("global:complaints.additionalCustomerInformation")}
            name="additionalCustomerInformation"
            data-cy="additionalCustomerInformation"
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={t("global:complaints.requestedAdditionalServices")}
            name="requestedAdditionalServices"
            data-cy="requestedAdditionalServices"
          />
        </Col>
      </Row>

      {/* ----------------- INFORMACJE DODATKOWE ----------------- */}
      <BMXSeparator title={t("global:complaints.additionalInformation")} />

      <Row>
        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={t("global:complaints.deliveredWithDevice")}
            name="deliveredWithDevice"
            data-cy="deliveredWithDevice"
          />
        </Col>
      </Row>

      <Row>
        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={t("global:complaints.diagnosticCost")}
            name="diagnosticCost"
            data-cy="diagnosticCost"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXSelectField}
            values={guarantorSelect?.map((el) => ({
              name: el.entryName,
              value: el.uuid,
            }))}
            label={t("global:complaints.guarantor")}
            name="guarantor"
            data-cy="guarantor"
          />
        </Col>
      </Row>
    </div>
  );
};

export default ComplaintsFormStepTwo;
